var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('legend', [_vm._v("Set Shipment Status")]), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.MarkPod == 1),
      expression: "MarkPod == 1"
    }]
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShippingId),
      expression: "ShippingId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ShippingId')
    },
    attrs: {
      "id": "ShippingId",
      "type": "text",
      "name": "ShippingId",
      "placeholder": "Please Enter Shipping Id",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.ShippingId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShippingId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ShippingId')),
      expression: "errors.has('form-1.ShippingId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Shipment Id.")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-prepend col-md-6"
  }, [_vm._m(2), _vm._v(" \n                       "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isgetShipmentLoad,
      "text": "Please wait capturing shipment details..."
    },
    on: {
      "update:active": function($event) {
        _vm.isgetShipmentLoad = $event
      }
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.MarkPod == 0),
      expression: "MarkPod == 0"
    }]
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Shipment Type : ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bulkShipmenttype),
      expression: "bulkShipmenttype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('ShipmentType')
    },
    attrs: {
      "name": "bulkShipmenttype",
      "id": "bulkShipmenttype",
      "disabled": "disabled"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bulkShipmenttype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.bulkShipmenttype
    }
  }, [_vm._v("Delivery")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.shipmenttype')),
      expression: "errors.has('form-2.shipmenttype')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Delivery Type")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Select Hub :  ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bulkHubname),
      expression: "bulkHubname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('bulkHubname')
    },
    attrs: {
      "name": "bulkHubname",
      "id": "bulkHubname",
      "disabled": "disabled"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bulkHubname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.CurrentUserAccessHubObj.HubID
    }
  }, [_vm._v(_vm._s(_vm.CurrentUserAccessHubObj.HubName))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.bulkHubname')),
      expression: "errors.has('form-2.bulkHubname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Hub")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Delivery User :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.DeliveryUserList,
      "selected-option": _vm.deliveryObj,
      "name": "deliverUserName",
      "placeholder": "Select user"
    },
    on: {
      "select": _vm.getdeliverySelect
    },
    model: {
      value: (_vm.deliverUserName),
      callback: function($$v) {
        _vm.deliverUserName = $$v
      },
      expression: "deliverUserName"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('deliverUserName')),
      expression: "errors.has('deliverUserName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('deliverUserName')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticClass: "topspace input-group mt-2"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.deliverUserName == ''
    },
    on: {
      "click": function($event) {
        return _vm.getShipmentList('notifyError')
      }
    }
  }, [_vm._v("Show")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.bulkClear
    }
  }, [_vm._v("Reset")])])], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isBulkPodLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isBulkPodLoading = $event
      }
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.MarkPod == 0 && _vm.BulkUpdateFlag == 1),
      expression: "MarkPod == 0 && BulkUpdateFlag == 1"
    }],
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Update Shipment status")]), _vm._v(" "), _c('div', {
    staticClass: "card card-body"
  }, [_c('div', {
    staticClass: "bulk-update"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "bulkFormpdate"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit('bulkFormpdate')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Delivery Date : ")]), _vm._v(" "), _c('b-input-group', [_c('v-date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('DeliveryDate')
    },
    attrs: {
      "min-date": new Date(_vm.disablePrevDate),
      "max-date": new Date(),
      "placeholder": "Select Delivery Date",
      "name": "DeliveryDate",
      "id": "DeliveryDate"
    },
    model: {
      value: (_vm.dateobj.DeliveryDate),
      callback: function($$v) {
        _vm.$set(_vm.dateobj, "DeliveryDate", $$v)
      },
      expression: "dateobj.DeliveryDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bulkFormpdate.DeliveryDate')),
      expression: "errors.has('bulkFormpdate.DeliveryDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Delivery Date.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Time : ")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateobj.DeliveryTime),
      expression: "dateobj.DeliveryTime"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('DeliveryTime')
    },
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "id": "DeliveryTime",
      "type": "time",
      "name": "DeliveryTime",
      "minlength": "4",
      "maxlength": "4",
      "placeholder": " Time"
    },
    domProps: {
      "value": (_vm.dateobj.DeliveryTime)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dateobj, "DeliveryTime", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bulkFormpdate.DeliveryTime')),
      expression: "errors.has('bulkFormpdate.DeliveryTime')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Delivery Time.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Status Code : ")]), _vm._v(" "), _c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BulkDeliveryStatus),
      expression: "BulkDeliveryStatus"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('BulkDeliveryStatus')
    },
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "name": "BulkDeliveryStatus",
      "id": "BulkDeliveryStatus"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.BulkDeliveryStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.BulkcheckStatusCode()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select Status Code--")]), _vm._v(" "), _vm._l((_vm.statusListObj), function(statusCode) {
    return _c('option', {
      domProps: {
        "value": statusCode.uniquecode
      }
    }, [_vm._v(_vm._s(statusCode.uniquecode) + " - " + _vm._s(statusCode.userprocess))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bulkFormpdate.BulkDeliveryStatus')),
      expression: "errors.has('bulkFormpdate.BulkDeliveryStatus')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Status Code.")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bulkDisputeDetailsShow == true),
      expression: "bulkDisputeDetailsShow == true"
    }],
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Dispute Status Code : ")]), _vm._v(" "), _c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BulkDisputeStatus),
      expression: "BulkDisputeStatus"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.bulkDisputeDetailsShow == true ? 'required' : ''),
      expression: "bulkDisputeDetailsShow == true ? 'required' : '' "
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('BulkDisputeStatus')
    },
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "name": "BulkDisputeStatus",
      "id": "BulkDisputeStatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.BulkDisputeStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select Status Code--")]), _vm._v(" "), _vm._l((_vm.disputeListObj), function(disputeCode) {
    return _c('option', {
      domProps: {
        "value": disputeCode.uniquecode
      }
    }, [_vm._v(_vm._s(disputeCode.uniquecode) + " - " + _vm._s(disputeCode.userprocess))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bulkFormpdate.BulkDisputeStatus')),
      expression: "errors.has('bulkFormpdate.BulkDisputeStatus')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Dispute Code.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticClass: "topspace input-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.bulkMiniClear
    }
  }, [_vm._v("Reset")])])], 1)])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isBulkShipmentListLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isBulkShipmentListLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        return _vm.selectAllShipments($event)
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("ShippingID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Ship Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Ship Address")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Ship City")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Ship State")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Ship Pincode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Ship MobileNo")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Net Payment")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("OrderType")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Delivery UserName")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Delivery Mobile")])])]), _vm._v(" "), _c('tbody', [(_vm.LatmileShipmentData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "14",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._l((_vm.LatmileShipmentData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedShipmentData),
        expression: "selectedShipmentData"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data.ShippingID,
        "checked": Array.isArray(_vm.selectedShipmentData) ? _vm._i(_vm.selectedShipmentData, data.ShippingID) > -1 : (_vm.selectedShipmentData)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedShipmentData,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.ShippingID,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedShipmentData = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedShipmentData = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedShipmentData = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShipName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShipAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShipCity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShipState))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShipPincode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShipMobile))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.NetPayment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.OrderType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShipmentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.SRName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.SRMobileNo))])])
  })], 2)]), _vm._v(" "), _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1), _vm._v(" "), _c('Forward-bulk-status', {
    ref: "childForwardComp",
    attrs: {
      "isForwardBulkReportLoader": _vm.isForwardBulkReportLoader,
      "showForwardBulkReportStatus": _vm.showForwardBulkReportStatus
    },
    model: {
      value: (_vm.showForwardBulkModel),
      callback: function($$v) {
        _vm.showForwardBulkModel = $$v
      },
      expression: "showForwardBulkModel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 input-group"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shippingDetailsShow == true),
      expression: "shippingDetailsShow == true"
    }],
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.getHubObj.ShippId))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.getHubObj.ShipName))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.getHubObj.ShipAddress))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.getHubObj.ShipCity))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.getHubObj.ShipState))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.getHubObj.ShipPinCode))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(" - ")])])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.altCustomerDetailsShow == true),
      expression: "altCustomerDetailsShow == true"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.getHubObj.ShipAltAddress) + " ")])])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.altCustomerDetailsShow == true),
      expression: "altCustomerDetailsShow == true"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.getHubObj.ShipAltPinCode))])])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.altCustomerDetailsShow == true),
      expression: "altCustomerDetailsShow == true"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(13), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.getHubObj.ShipAltMobileNo) + " ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(14), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.getHubObj.NetPayment))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(15), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.getHubObj.OrderType))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(16), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.getHubObj.ShipmentStatus))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(17), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.getHubObj.DeliveryStatus))])])], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shippingDetailsShow == true),
      expression: "shippingDetailsShow == true"
    }],
    staticClass: "col-md-6"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-2",
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm2('form-2')
      }
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(19), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.getHubObj.DeliveryUsername))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(20), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.getHubObj.DeliveryUserID))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(21), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.getHubObj.MobileNo) + "  ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(22), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8 float-left"
  }, [_c('v-date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('DeliveryDate')
    },
    attrs: {
      "min-date": new Date(_vm.disablePrevDate),
      "max-date": new Date(),
      "placeholder": "Select Delivery Date",
      "name": "DeliveryDate",
      "id": "DeliveryDate"
    },
    model: {
      value: (_vm.dateobj.DeliveryDate),
      callback: function($$v) {
        _vm.$set(_vm.dateobj, "DeliveryDate", $$v)
      },
      expression: "dateobj.DeliveryDate"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateobj.DeliveryTime),
      expression: "dateobj.DeliveryTime"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('DeliveryTime')
    },
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "id": "DeliveryTime",
      "type": "time",
      "name": "DeliveryTime",
      "minlength": "4",
      "maxlength": "4",
      "placeholder": " Time"
    },
    domProps: {
      "value": (_vm.dateobj.DeliveryTime)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dateobj, "DeliveryTime", $event.target.value)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.DeliveryDate')),
      expression: "errors.has('form-2.DeliveryDate')"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "173px"
    }
  }, [_vm._v("Please Select Delivery Date.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.DeliveryTime')),
      expression: "errors.has('form-2.DeliveryTime')"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "173px"
    }
  }, [_vm._v("Please Enter Delivery Time.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(23), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('DeliveryStatus')
    },
    attrs: {
      "options": _vm.statusListObj,
      "selected-option": _vm.statusObj,
      "name": "DeliveryStatus",
      "placeholder": "--Select Status Code--"
    },
    on: {
      "select": _vm.checkStatusCode
    },
    model: {
      value: (_vm.DeliveryStatus),
      callback: function($$v) {
        _vm.DeliveryStatus = $$v
      },
      expression: "DeliveryStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.DeliveryStatus')),
      expression: "errors.has('form-2.DeliveryStatus')"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "173px"
    }
  }, [_vm._v("Please Select Status Code.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disputeDetailsShow == true),
      expression: "disputeDetailsShow == true"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(24), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.DisputeStatus),
      expression: "DisputeStatus"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.disputeDetailsShow == true ? 'required' : ''),
      expression: "disputeDetailsShow == true ? 'required' : '' "
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('DisputeStatus')
    },
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "name": "DisputeStatus",
      "id": "DisputeStatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.DisputeStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select Status Code--")]), _vm._v(" "), _vm._l((_vm.disputeListObj), function(disputeCode) {
    return _c('option', {
      domProps: {
        "value": disputeCode.uniquecode
      }
    }, [_vm._v(_vm._s(disputeCode.uniquecode) + " - " + _vm._s(disputeCode.title))])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.DisputeStatus')),
      expression: "errors.has('form-2.DisputeStatus')"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "173px"
    }
  }, [_vm._v("Please Select Dispute Code.")])]), _vm._v(" "), (_vm.DeliveryStatus == 'XBU00042') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(25), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iswrongPincode),
      expression: "iswrongPincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^[0-9]{6,6}$/
      }),
      expression: "{required: true,regex:/^[0-9]{6,6}$/}"
    }],
    attrs: {
      "id": "iswrongPincode",
      "type": "text",
      "name": "iswrongPincode",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.iswrongPincode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.iswrongPincode = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.iswrongPincode')),
      expression: "errors.has('form-2.iswrongPincode')"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "173px"
    }
  }, [_vm._v("Please Enter 6 Digit Pincode.!")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.receiverTypeShow == true),
      expression: "receiverTypeShow == true"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(26), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ReceiverType),
      expression: "ReceiverType"
    }],
    attrs: {
      "id": "ReceiverType1",
      "type": "radio",
      "name": "ReceiverType",
      "checked": "checked",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.ReceiverType, "0")
    },
    on: {
      "change": [function($event) {
        _vm.ReceiverType = "0"
      }, function($event) {
        return _vm.checkReceiverType()
      }]
    }
  }), _vm._v(" Self\n                    ")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ReceiverType),
      expression: "ReceiverType"
    }],
    attrs: {
      "id": "ReceiverType2",
      "type": "radio",
      "name": "ReceiverType",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.ReceiverType, "1")
    },
    on: {
      "change": [function($event) {
        _vm.ReceiverType = "1"
      }, function($event) {
        return _vm.checkReceiverType()
      }]
    }
  }), _vm._v(" Other\n                    ")])])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.podMarkOnShow == true),
      expression: "podMarkOnShow == true"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(27), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PodMarkOnType),
      expression: "PodMarkOnType"
    }],
    attrs: {
      "id": "PodMarkOnType1",
      "type": "radio",
      "name": "PodMarkOnType",
      "checked": "checked",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.PodMarkOnType, "0")
    },
    on: {
      "change": function($event) {
        _vm.PodMarkOnType = "0"
      }
    }
  }), _vm._v(" Primary\n                    ")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PodMarkOnType),
      expression: "PodMarkOnType"
    }],
    attrs: {
      "id": "PodMarkOnType2",
      "type": "radio",
      "name": "PodMarkOnType",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.PodMarkOnType, "1")
    },
    on: {
      "change": function($event) {
        _vm.PodMarkOnType = "1"
      }
    }
  }), _vm._v(" Alternate\n                    ")])])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.BPPackageIDShow == true),
      expression: "BPPackageIDShow == true"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(28), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BPackingID),
      expression: "BPackingID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.BPPackageIDShow == true ? 'required' : ''),
      expression: "BPPackageIDShow == true ? 'required' : '' "
    }],
    key: _vm.isAllowManualEntryBP,
    staticClass: "form-control",
    class: {
      'form-control': true
    },
    attrs: {
      "id": "BPackingID",
      "type": "text",
      "oncopy": "return false",
      "onpaste": "return false",
      "name": "BPackingID",
      "autocomplete": "off",
      "placeholder": "Enter Branded Packing ID"
    },
    domProps: {
      "value": (_vm.BPackingID)
    },
    on: {
      "keydown": _vm.KeyHandle,
      "keypress": _vm.isLetterOrNumber,
      "drop": _vm.handleDragOver,
      "change": _vm.ValidateBrandedPkgId,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.BPackingID = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.BPackingID')),
      expression: "errors.has('form-2.BPackingID')"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "173px"
    }
  }, [_vm._v("Please enter Branded Packing ID.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ReceiverMobNoShow == true),
      expression: "ReceiverMobNoShow == true"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(29), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ReceiverMobNo),
      expression: "ReceiverMobNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.ReceiverMobNoShow == true ? 'required' : ''),
      expression: "ReceiverMobNoShow == true ? 'required' : ''"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true
    },
    attrs: {
      "id": "ReceiverMobNo",
      "type": "text",
      "name": "ReceiverMobNo",
      "placeholder": "Enter Receiver Mobile Number",
      "minlength": "10",
      "maxlength": "12"
    },
    domProps: {
      "value": (_vm.ReceiverMobNo)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ReceiverMobNo = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.ReceiverMobNo')),
      expression: "errors.has('form-2.ReceiverMobNo')"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "173px"
    }
  }, [_vm._v("Please enter receiver mobile number.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(30), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ReceiverName),
      expression: "ReceiverName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.IsReceiverNameDisabled == false ? 'required' : ''),
      expression: "IsReceiverNameDisabled == false ? 'required' : ''"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true
    },
    attrs: {
      "id": "ReceiverName",
      "type": "text",
      "name": "ReceiverName",
      "placeholder": "Enter Receiver Name",
      "disabled": _vm.IsReceiverNameDisabled == true
    },
    domProps: {
      "value": (_vm.ReceiverName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ReceiverName = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.ReceiverName')),
      expression: "errors.has('form-2.ReceiverName')"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "173px"
    }
  }, [_vm._v("Please enter receiver name.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(31), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NetPaymentReceived),
      expression: "NetPaymentReceived"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "NetPaymentReceived",
      "type": "text",
      "name": "NetPaymentReceived",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.NetPaymentReceived)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.NetPaymentReceived = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.PODImageShow == true),
      expression: "PODImageShow == true"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(32), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.PODImageShow == true ? 'required' : ''),
      expression: "PODImageShow == true ? 'required' : ''"
    }],
    ref: "PODImage",
    staticClass: "form-control",
    attrs: {
      "id": "PODImage",
      "type": "file",
      "name": "PODImage",
      "accept": ".png, .jpg, .jpeg, .gif, .bmp"
    },
    on: {
      "change": function($event) {
        return _vm.onuploadChange($event)
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.PODImage')),
      expression: "errors.has('form-2.PODImage')"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "173px"
    }
  }, [_vm._v("Please upload image.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.RelationWithConsigneeShow == true),
      expression: "RelationWithConsigneeShow == true"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(33), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RelationWithConsignee),
      expression: "RelationWithConsignee"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.RelationWithConsigneeShow == true ? 'required' : ''),
      expression: "RelationWithConsigneeShow == true ? 'required' : ''"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "name": "RelationWithConsignee",
      "id": "RelationWithConsignee"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.RelationWithConsignee = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.consigneeListObj), function(consigneeList) {
    return _c('option', {
      domProps: {
        "value": consigneeList.RelationName
      }
    }, [_vm._v(_vm._s(consigneeList.RelationName))])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.RelationWithConsignee')),
      expression: "errors.has('form-2.RelationWithConsignee')"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "173px"
    }
  }, [_vm._v("Please Select Relation with Consignee.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IDProofListShow == true),
      expression: "IDProofListShow == true"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(34), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.IDProof),
      expression: "IDProof"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.IDProofListShow == true ? 'required' : ''),
      expression: "IDProofListShow == true ? 'required' : ''"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "name": "IDProof",
      "id": "IDProof"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.IDProof = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.idProofListObj), function(idProofCode) {
    return _c('option', {
      domProps: {
        "value": idProofCode.proofName
      }
    }, [_vm._v(_vm._s(idProofCode.proofName))])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.IDProof')),
      expression: "errors.has('form-2.IDProof')"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "173px"
    }
  }, [_vm._v("Please Select ID Proof option.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IDProofListShow == true),
      expression: "IDProofListShow == true"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(35), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.IDProofNo),
      expression: "IDProofNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.IDProofListShow == true ? 'required' : ''),
      expression: "IDProofListShow == true ? 'required' : ''"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "IDProofNo",
      "type": "text",
      "name": "IDProofNo",
      "placeholder": "Enter ID Proof Number"
    },
    domProps: {
      "value": (_vm.IDProofNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.IDProofNo = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.IDProofNo')),
      expression: "errors.has('form-2.IDProofNo')"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "173px"
    }
  }, [_vm._v("Please enter ID Proof number.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reattemptDeliveryDateShow == true),
      expression: "reattemptDeliveryDateShow == true"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(36), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8 float-left"
  }, [_c('v-date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.reattemptDeliveryDateShow == true ? 'required' : ''),
      expression: "reattemptDeliveryDateShow == true ? 'required' : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('ReattemptDate')
    },
    attrs: {
      "min-date": new Date(),
      "placeholder": "Select ReattemptDate Date",
      "name": "ReattemptDate"
    },
    model: {
      value: (_vm.dateobj.ReattemptDate),
      callback: function($$v) {
        _vm.$set(_vm.dateobj, "ReattemptDate", $$v)
      },
      expression: "dateobj.ReattemptDate"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.ReattemptDate')),
      expression: "errors.has('form-2.ReattemptDate')"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "173px"
    }
  }, [_vm._v("Please Select Reattempt Date.")])]), _vm._v(" "), _c('div', [(_vm.NdrOTPFlag == true) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(37), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.UserOTP),
      expression: "UserOTP"
    }],
    ref: "UserOTP",
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('UserOTP')
    },
    attrs: {
      "id": "UserOTP",
      "type": "text",
      "name": "UserOTP",
      "placeholder": "Enter code",
      "minlength": "4",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.UserOTP)
    },
    on: {
      "change": _vm.VerifyNdrotpfeature,
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.UserOTP = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.UserOTP')),
      expression: "errors.has('form-1.UserOTP')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Code.")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.VerifyOTP
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Verify Code")]), _vm._v(" \n                    ")])], 1)]) : _vm._e()]), _vm._v(" "), (_vm.DeliveryStatus == 'XBU00219') ? _c('div', {
    staticClass: "form-group"
  }, [(_vm.NDRSecurityCode != '' && _vm.NDRSecurityCode != 'null' && _vm.NDRSecurityCode != null && _vm.NDRSecurityCode != 'undefined') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(38), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8 float-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveryCodeVerify),
      expression: "deliveryCodeVerify"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|isDeliveryCodeMax'),
      expression: "'required|isDeliveryCodeMax'"
    }],
    ref: "deliveryCodeVerify",
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('deliveryCodeVerify')
    },
    attrs: {
      "id": "deliveryCodeVerify",
      "type": "text",
      "placeholder": "Enter delivery code",
      "name": "deliveryCodeVerify"
    },
    domProps: {
      "value": (_vm.deliveryCodeVerify)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deliveryCodeVerify = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.deliveryCodeVerify')),
      expression: "errors.has('form-2.deliveryCodeVerify')"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "175px"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('form-2.deliveryCodeVerify')))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingPrint,
      "text": "Please wait Shipment is being processing..."
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPrint = $event
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit",
      "disabled": (_vm.verifyOTPFlag == 'false')
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Update Shipment Status ")])], 1)])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "IsOpenDeliveryModal",
      "size": "modal-dialog modal-lg",
      "no-close-on-backdrop": true
    },
    model: {
      value: (_vm.IsOpenDeliveryModal),
      callback: function($$v) {
        _vm.IsOpenDeliveryModal = $$v
      },
      expression: "IsOpenDeliveryModal"
    }
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 lg-auto"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-3"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm3('form-3')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDeliveryTypeOpen == true),
      expression: "isDeliveryTypeOpen == true"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                        Sub Status Code\n                      ")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.DeliverySubStatus),
      expression: "DeliverySubStatus"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.isDeliveryTypeOpen == true ? 'required' : ''),
      expression: "isDeliveryTypeOpen == true ? 'required' : '' "
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('DeliverySubStatus')
    },
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "name": "DeliverySubStatus",
      "id": "DeliverySubStatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.DeliverySubStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select Status Code--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "XBU00345-Customer refused to open package"
    }
  }, [_vm._v("Customer refused to open package")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "XBU00346-Delivered to neighbour"
    }
  }, [_vm._v("Delivered to neighbour")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "XBU00347-Delivered to security"
    }
  }, [_vm._v("Delivered to security")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "XBU00348-Delivered at address to relative"
    }
  }, [_vm._v("Delivered at address to relative")])])])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-3.DeliverySubStatus')),
      expression: "errors.has('form-3.DeliverySubStatus')"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "205px"
    }
  }, [_vm._v("Please Select Sub Status Code.")])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary float-right",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit ")])])])])])])], 1)], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bulk-pod",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-8"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Shipment ID : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('legend', [_c('div', {
    staticClass: "input-group-prepend col-md-6"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Shipment Details\n                    ")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      ShippingID\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Ship Name :\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      ShipAddress\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      ShipCity\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      ShipState\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      ShipPinCode\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      ShipMobileNo\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Alternate Address\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Alternate Pincode\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Alternate Mobile No\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      NetPayment\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      OrderType\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Shipment Status\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Delivery Status\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('legend', [_c('div', {
    staticClass: "input-group-prepend col-md-6"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Update Shipment Details\n                    ")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Delivery UserName\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Delivery UserId\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Mobile No\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Delivery Date\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Status Code\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Dispute Status Code\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Pincode\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Received By\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      POD Mark On\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Branded Packing ID\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Receiver Mobile No\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Receiver Name\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      NetPayment Received\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Upload Image\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Relation With Consignee\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      ID Proof\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      ID Proof No\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                      Reattempt Date\n                    ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v(" Code : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v(" Delivery Code : ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15c6ccc0","hasScoped":false}!./src/views/components/SetShipmentStatus/SetShipmentStatus.component.html
// module id = 1129
// module chunks = 1